import PopupMessage from '../../components/PopupMessage/PopupMessage'
import { useState } from 'react'

export default function GovpayDashboard() {
    const [uploadedFile, setUploadedFile] = useState(null)
    const [popup, setPopup] = useState({ message: '', type: '', shown: false })
    const openPopup = () => {
        setPopup(values => ({
            ...values,
            shown: true,
            message: (
                <>
                    <div className="flex flex-col">
                        <p>
                            Απαιτείται μεγαλύτερου επιπέδου πρόσβαση για να
                            εκτελέσετε αυτή την ενέργεια
                        </p>
                    </div>
                </>
            ),
            type: 'error',
        }))
    }

    const handleFileUpload = event => {
        if (event.target.files.length > 0) {
            setUploadedFile(event.target.files[0].name)
        }
    }

    return (
        <>
            {popup.shown && (
                <PopupMessage
                    message={popup.message}
                    type={popup.type}
                    closePopUp={() =>
                        setPopup(values => ({ ...values, shown: false }))
                    }
                    showCloseButton={true}
                />
            )}
            <div className="p-6 bg-white min-h-screen flex flex-col items-center">
                {/* Header Section */}
                <div className="w-full bg-primary text-white text-center p-4 font-bold text-lg rounded-md">
                    Υπηρεσία συγχρονισμού δεδομένων συστήματα οικονομικής
                    διαχείρισης
                </div>

                {/* Main Info Section */}
                <div className="w-3/4 bg-blue-100 p-6 mt-4 text-center rounded-lg shadow-md">
                    <p>
                        Μέσα από την υπηρεσία Govpay connect μπορείτε να
                        ανεβάσετε τις κινήσεις λογαριασμών από όλες τις
                        συστημικές τράπεζες που συνεργάζεται ο Δήμος ή τα νομικά
                        πρόσωπα. Ενδεικτικά αρχεία CSV, JSON, XML.
                    </p>
                    <p className="mt-4">
                        Στην περίπτωση που το σύστημα εντοπίσει πληρωμές με
                        αιτιολογία ΔΙΑ (RF) ή Ειδικό κωδικό πληρωμής Govpay τότε
                        θα επιβεβαιώσει αυτόματα την πληρωμή και το ποσό για το
                        ΑΦΜ χρήστη της υπηρεσίας πληρωμών.
                    </p>
                </div>

                {/* Buttons */}
                <div className="flex gap-4 mt-6">
                    <div className="flex flex-col items-center gap-4">
                        <label className="bg-accent  text-white font-bold py-2 px-4 rounded shadow cursor-pointer">
                            Ανέβασμα Αρχείου
                            <input
                                onChange={handleFileUpload}
                                type="file"
                                className="hidden"
                            />
                        </label>
                        {uploadedFile && (
                            <p className="text-gray-700">{uploadedFile}</p>
                        )}
                    </div>

                    <button
                        onClick={() => openPopup()}
                        className="bg-accent  text-white font-bold py-2 px-4 rounded shadow"
                    >
                        Προβολή εκκαθάρισης
                    </button>
                </div>

                {/* Reports Section */}
                <div className="w-3/4 bg-primary text-white text-center p-4 font-bold text-lg mt-6 rounded-lg shadow-md">
                    ΑΝΑΦΟΡΕΣ
                </div>

                <div className="flex gap-4 mt-4">
                    <button
                        onClick={() => openPopup()}
                        className="bg-accent  text-white font-bold py-2 px-4 rounded shadow"
                    >
                        Επιβεβαιωμένες πληρωμές περιόδου
                    </button>
                    <button
                        onClick={() => openPopup()}
                        className="bg-accent  text-white font-bold py-2 px-4 rounded shadow"
                    >
                        Αναφορά υπολοίπων
                    </button>
                </div>

                {/* API Section */}
                <a
                    href="/swagger"
                    target="_blank"
                    rel="norefferer"
                    className="w-3/4 bg-primary text-white text-center p-4 font-bold text-lg mt-6 rounded-lg shadow-md"
                >
                    API ΔΙΑΛΕΙΤΟΥΡΓΙΚΟΤΗΤΑΣ
                </a>
                <div className="bg-white p-6 rounded-lg border border-gray-300 w-full max-w-[60%] mx-auto my-6">
                    <h2 className="bg-primary text-white p-3 rounded-t-lg text-center font-bold">
                        Σύνδεση εγγραφής ενημέρωσης με οικονομική Διαχείριση
                    </h2>
                    <div className="p-4 bg-white rounded-b-lg flex flex-col items-center">
                        <div className="mb-4 w-full">
                            <label className="block text-sm font-semibold text-gray-700">
                                Endpoint URL οικονομικής διαχείρισης
                            </label>
                            <input
                                type="text"
                                placeholder="http://..."
                                className="mt-1 p-2 w-full border border-gray-300 rounded"
                            />
                        </div>
                        <div className="mb-4 w-full">
                            <label className="block text-sm font-semibold text-gray-700">
                                Username
                            </label>
                            <input
                                type="text"
                                placeholder=""
                                className="mt-1 p-2 w-full border border-gray-300 rounded"
                            />
                        </div>
                        <div className="mb-4 w-full">
                            <label className="block text-sm font-semibold text-gray-700">
                                Password
                            </label>
                            <input
                                type="password"
                                placeholder=""
                                className="mt-1 p-2 w-full border border-gray-300 rounded"
                            />
                        </div>
                        <div className="mb-4 w-full">
                            <label className="block text-sm font-semibold text-gray-700">
                                IP Address
                            </label>
                            <input
                                type="text"
                                placeholder=""
                                className="mt-1 p-2 w-full border border-gray-300 rounded"
                            />
                        </div>
                        <button className="bg-accent text-white w-full py-2 rounded font-bold max-w-[70%] mx-auto">
                            Υποβολή
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
